import { useNotificationsRealtime } from '@/hooks/useNotificationsRealtime';

/** Mount once under AuthProvider; keeps a single Action Cable subscription while logged in. */
export default function NotificationsRealtimeBridge() {
  useNotificationsRealtime();
  return null;
}
